import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IEmployeeCostsResponse } from "@api/stores/employeeCosts/types";

import type { IPathBaseParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IEmployeeCostsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("users.employeeCosts");

export const employeeCosts = {
  ...getAllApis,
};
